import { ApiFilter } from "@result/rui/utils/api";

const isEmptyFilterValue = (value) => {
  if (value == null) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  return false;
};

const sanitizeFilterJson = (node) => {
  if (node == null) return null;
  if (typeof node !== "object") return node;

  if (Array.isArray(node)) {
    const arr = node
      .filter(Boolean)
      .map((item) => sanitizeFilterJson(item))
      .filter((item) => item != null);
    return arr.length > 0 ? arr : null;
  }

  if ("name" in node && "operator" in node) {
    if (!node?.name || !node?.operator || isEmptyFilterValue(node?.value)) {
      return null;
    }
    return node;
  }

  const sanitizedObj = Object.entries(node).reduce((acc, [key, value]) => {
    const sanitizedValue = sanitizeFilterJson(value);
    if (sanitizedValue != null) acc[key] = sanitizedValue;
    return acc;
  }, {});

  return Object.keys(sanitizedObj).length > 0 ? sanitizedObj : null;
};

/**
 * Converts user filter (ApiFilter/string/object) into a backend-safe query string,
 * while stripping invalid/empty filter nodes (e.g. EQ:'').
 */
export const normalizeUserFilterExpression = (filter) => {
  const apiFilter = new ApiFilter();
  apiFilter?.toJSON();
  const rawUser = filter?.toJSON?.() ?? filter ?? null;
  if (rawUser == null) return "";

  if (typeof rawUser === "string") {
    const normalized = rawUser.trim().replace(/^filter=/, "");
    if (!normalized) return "";

    try {
      const sanitizedFilter = new ApiFilter();
      sanitizedFilter.from(normalized);
      const sanitizedJson = sanitizeFilterJson(sanitizedFilter.toJSON?.());
      if (sanitizedJson == null) return "";

      const rebuiltFilter = new ApiFilter();
      rebuiltFilter.fromJson(sanitizedJson);
      return (rebuiltFilter.toQueryString() || "").trim();
    } catch {
      return "";
    }
  }

  if (typeof rawUser === "object") {
    const sanitizedJson = sanitizeFilterJson(rawUser);
    if (sanitizedJson == null) return "";

    try {
      const sanitizedFilter = new ApiFilter();
      sanitizedFilter.fromJson(sanitizedJson);
      return (sanitizedFilter.toQueryString() || "").trim();
    } catch {
      return "";
    }
  }

  return "";
};
